// src/reducers/adminReducer.js
import * as actionTypes from '../Actions/actionTypes';
import { toast } from 'react-toastify';
const initialState = {
  user: null,
  userData:[],
  paymentOptions: [],
  paymentRequests: [],
  dashboardData: {},
  transactions: [],
  orders:[],
  rewards:[],
  powers: [],
  dummyWallets: [],
  allWorkingIncome: [],
  allTeamGrowIncome: [],
  cappinguser: [],
  sip:[],
  progressMessage: "",
  warningMessage: "",
  completedMessage: true,
  installment:[],
  unpaidInstallment:[],
  slots: [],
  loading: false,
  error: {code:0,message:null},
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
    case actionTypes.FETCH_PAYMENT_OPTIONS_REQUEST:
    case actionTypes.FETCH_ALL_USERS_REQUESTS_REQUEST:
    case actionTypes.FETCH_ALL_PAYMENT_REQUESTS_REQUEST:
    case actionTypes.APPROVE_PAYMENT_REQUEST_REQUEST:
    case actionTypes.REJECT_PAYMENT_REQUEST_REQUEST:
    case actionTypes.APPROVE_REWARD_REQUEST_REQUEST:
    case actionTypes.REJECT_REWARD_REQUEST_REQUEST:  
    case actionTypes.FETCH_DASHBOARD_DATA_REQUEST:
    case actionTypes.FETCH_ALL_POWER_REQUEST:
    case actionTypes.FETCH_CAPPING_DATA_REQUEST:
    case actionTypes.FETCH_PAYMENT_TRANSACTIONS_REQUEST:
    case actionTypes.FETCH_ALL_ORDER_REQUEST:
    case actionTypes.FETCH_ALL_SIP_REQUEST:
    case actionTypes.FETCH_SIP_INSTALLMENT_REQUEST:
    case actionTypes.FETCH_ALL_WORKING_INCOME_REQUEST:
    case actionTypes.FETCH_ALL_TEAM_GROW_INCOME_REQUEST:
    case actionTypes.FETCH_UNPAID_INSTALLMENT_REQUEST:
    case actionTypes.FETCH_ALL_REWARD_REQUEST:
    case actionTypes.RELEASED_INCOME_REQUEST:
    case actionTypes.FETCH_ALL_SLOTS_REQUEST:
    case actionTypes.FETCH_ALL_DUMMY_WALLET_REQUEST:
    case actionTypes.UPDATE_SLOT_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.LOGIN_FAILURE:
    case actionTypes.FETCH_PAYMENT_OPTIONS_FAILURE:
    case actionTypes.FETCH_ALL_PAYMENT_REQUESTS_FAILURE:
    case actionTypes.FETCH_ALL_USERS_REQUESTS_FAILURE:
    case actionTypes.APPROVE_PAYMENT_REQUEST_FAILURE:
    case actionTypes.REJECT_PAYMENT_REQUEST_FAILURE:
    case actionTypes.APPROVE_REWARD_REQUEST_FAILURE:
    case actionTypes.REJECT_REWARD_REQUEST_FAILURE:
    case actionTypes.FETCH_DASHBOARD_DATA_FAILURE:
    case actionTypes.FETCH_ALL_POWER_FAILURE:
    case actionTypes.FETCH_CAPPING_DATA_FAILURE:
    case actionTypes.FETCH_PAYMENT_TRANSACTIONS_FAILURE:
    case actionTypes.FETCH_ALL_ORDER_FAILURE:
    case actionTypes.FETCH_ALL_SIP_FAILURE:
    case actionTypes.FETCH_SIP_INSTALLMENT_FAILURE:
    case actionTypes.FETCH_UNPAID_INSTALLMENT_FAILURE:
    case actionTypes.FETCH_ALL_WORKING_INCOME_FAILURE:
    case actionTypes.FETCH_ALL_TEAM_GROW_INCOME_FAILURE:
    case actionTypes.FETCH_ALL_REWARD_FAILURE:
    case actionTypes.RELEASED_INCOME_FAILURE:
    case actionTypes.FETCH_ALL_SLOTS_FAILURE:
    case actionTypes.FETCH_ALL_DUMMY_WALLET_FAILURE:
    case actionTypes.UPDATE_SLOT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actionTypes.SET_PROGRESS_MESSAGE:
      return {
        ...state,
        progressMessage: action.payload,
      };

    case actionTypes.SET_WARNING_MESSAGE:
      return {
        ...state,
        warningMessage: action.payload,
      };

    case actionTypes.SET_COMPLETED_MESSAGE:
      return {
        ...state,
        completedMessage: action.payload,
      };

    case actionTypes.LOGIN_SUCCESS:
    // toast.success(action.payload.message);
    localStorage.setItem('authToken', action.payload.token);
      return { ...state, loading: false, user: action.payload, error: null };

      case actionTypes.LOGOUT:
        return { ...state, user: null };

    case actionTypes.FETCH_PAYMENT_OPTIONS_SUCCESS:
      return { ...state, loading: false, paymentOptions: action.payload, error: null };

    case actionTypes.FETCH_ALL_PAYMENT_REQUESTS_SUCCESS:
      return { ...state, loading: false, paymentRequests: action.payload, error: null };
      
    case actionTypes.FETCH_ALL_ORDER_SUCCESS:
      return { ...state, loading: false, orders: action.payload, error: null };

    case actionTypes.FETCH_ALL_SIP_SUCCESS:
      return { ...state, loading: false, sip: action.payload, error: null };
    
    case actionTypes.FETCH_SIP_INSTALLMENT_SUCCESS:
      return { ...state, loading: false, installment: action.payload, error: null };

    case actionTypes.FETCH_UNPAID_INSTALLMENT_SUCCESS:
      return { ...state, loading: false, unpaidInstallment: action.payload, error: null };

    case actionTypes.FETCH_ALL_DUMMY_WALLET_SUCCESS:
      return { ...state, loading: false, dummyWallets: action.payload, error: null };

    case actionTypes.FETCH_ALL_REWARD_SUCCESS:
      return { ...state, loading: false, rewards: action.payload, error: null };

    case actionTypes.FETCH_ALL_TEAM_GROW_INCOME_SUCCESS:
      return { ...state, loading: false, allTeamGrowIncome: action.payload, error: null };

    case actionTypes.FETCH_ALL_POWER_SUCCESS:
      return { ...state, loading: false, powers: action.payload, error: null };

    case actionTypes.FETCH_CAPPING_DATA_SUCCESS:
      return { ...state, loading: false, cappinguser: action.payload, error: null };

    case actionTypes.FETCH_ALL_WORKING_INCOME_SUCCESS:
      return { ...state, loading: false, allWorkingIncome: action.payload, error: null };

    case actionTypes.FETCH_ALL_SLOTS_SUCCESS:
      return { ...state, loading: false, slots: action.payload, error: null };

    case actionTypes.UPDATE_SLOT_SUCCESS:
      return { ...state, loading: false, error: null };

    case actionTypes.FETCH_ALL_USERS_REQUESTS_SUCCESS:
      return { ...state, loading: false, userData: action.payload, error: null };

    case actionTypes.APPROVE_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
       
        error: null,
      };

    case actionTypes.REJECT_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        // paymentRequests: state.paymentRequests.filter(request => request.id !== action.payload.id),
        error: null,
      };

      case actionTypes.APPROVE_REWARD_REQUEST_SUCCESS:
        return {
          ...state,
          loading: false,
         
          error: null,
        };
  
      case actionTypes.REJECT_REWARD_REQUEST_SUCCESS:
        return {
          ...state,
          loading: false,
          // paymentRequests: state.paymentRequests.filter(request => request.id !== action.payload.id),
          error: null,
        };  

        case actionTypes.RELEASED_INCOME_SUCCESS:
          return {
            ...state,
            loading: false,
           
            error: null,
          };

    case actionTypes.FETCH_DASHBOARD_DATA_SUCCESS:
      return { ...state, loading: false, dashboardData: action.payload, error: null };

    case actionTypes.FETCH_PAYMENT_TRANSACTIONS_SUCCESS:
      return { ...state, loading: false, transactions: action.payload, error: null };

    default:
      return state;
  }
};

export default adminReducer;
